import RoomType from '../roomType';
export default class Office extends RoomType {
    constructor() {
        super();
        this.id = 'Office';
        this.name = "Kontor";
        this.icon = "mdi-monitor";
        this.stateQuestions.questions.push(
            {
                'id': 'windows',
                'title': 'Vinduer og karmer',
                'active': true,
                'value': -1
            },
            {
                'id': 'desk',
                'title': 'Pult',
                'active': true,
                'value': -1
            }
        );
    }
}